import { CKEditorService } from './../../../../../services/ckeditor.service';
import { ProjectDataDisplayModelFormGroup } from './../../../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/project-data-display-model';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';
import { StateService } from '@/core/services/state.service';
import { Constants } from '@/constants';
import * as CustomEditor from '@ckeditor/ckeditor5-build-classic';
import { I18nService } from '@/core/services/i18nService';
import { dateABeforeDateBValidator, projektstartValidator } from '@/core/validators/customform.validators';

@Component({
  selector: 'project-data',
  templateUrl: './project-data.component.html',
  styleUrls: ['./project-data.component.scss']
})
export class ProjectDataComponent implements OnInit {

  @Input() aiResponse = "";
  @Input() aiResponseLoading = false;
  @Input() aiResponseFinished = false;

  public Editor = CustomEditor;

  public editorConfig = Constants.EDITOR_CONFIG;
  public projectDataConfig = Constants.PROJECT_DATA;
  
  public get dateFormat(): string{
    return this.translateService.GetCurrentShortDateFormat(true);
  }

  @Input('form') public projectDataForm: ProjectDataDisplayModelFormGroup;

  constructor(public ckeditorService: CKEditorService, public translateService: I18nService, protected stateService: StateService) { 
  }

  ngOnInit(): void {
    this.projectDataForm.ProjektStart.addValidators(projektstartValidator);

    this.projectDataForm.addValidators(dateABeforeDateBValidator(this.projectDataForm.ProjektEnd, this.projectDataForm.ProjektStart));

    if (this.stateService.IsEndvalidationEnabled) {
      this.projectDataForm.Title.addValidators(Validators.required);
      this.projectDataForm.ProjektStart.addValidators(Validators.required);
      this.projectDataForm.ProjektEnd.addValidators(Validators.required);
      this.projectDataForm.Projektbeschreibung.addValidators(Validators.required);
      this.projectDataForm.Projektbeteiligte.addValidators(Validators.required);
      this.projectDataForm.markAllAsTouched();
    }
  }

  onProjektStartChange(event: any): void {
    this.projectDataForm.ProjektEnd.setValue(null);
  }

  get endBeforeStartErrorMessage(): string {
    if (this.projectDataForm.errors?.dateAAfterDateB)
      return this.translateService.instant('project-data.plannedProjectEnd.invalid');

    return "";
  }

  public initCKEditor(editor: any, containerId: string) {
    if(containerId == "word-count-projektbeschreibung") {
      this.ckeditorService.rows(5).initWordCount(editor, containerId, this.projectDataConfig.PROJEKTBESCHREIBUNG_MAXLENGTH);
      this.projectDataForm.Projektbeschreibung.valueChanges.subscribe(value => {
        this.ckeditorService.validateLength(editor, this.projectDataConfig.PROJEKTBESCHREIBUNG_MAXLENGTH)
      })
    }

    if(containerId == "word-count-projektbeteiligte") {
      this.ckeditorService.rows(5).initWordCount(editor, containerId, this.projectDataConfig.PROJEKTBETEILIGTE_MAXLENGTH);
      this.projectDataForm.Projektbeteiligte.valueChanges.subscribe(value => {
        this.ckeditorService.validateLength(editor, this.projectDataConfig.PROJEKTBETEILIGTE_MAXLENGTH)
      })
    }
  }
}
